/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Aborted_ToastInputs */



/**
* | output |
* | --- |
* | "Export Aborted" |
*
* @param {Audio_Description_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_aborted_toast = /** @type {((inputs?: Audio_Description_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation annulée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export abgebrochen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione interrotta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт прерван")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación abortada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出已中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートが中止されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação abortada")
	return /** @type {LocalizedString} */ ("Export Aborted")
});